<template>
  <div class='notification-list'>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>企业信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="20" style="margin-bottom: 30px;">
      <el-col :span="6">
        <el-menu
          class="el-menu-vertical-demo"
          :unique-opened="true" @select="selectMenu" :default-active="'0-0'" v-loading="loading">
          <el-menu-item index="0-0">
            <span slot="title">全部</span>
          </el-menu-item>
          <el-menu-item v-for="c in categoryList" :key="c.id" :index="c.id+''">
            <template slot="title">
              <span>{{c.name}}</span>
            </template>
          </el-menu-item>
          <!-- <el-submenu v-for="c in categoryList" :key="c.id" :index="c.id+''">
            <template slot="title">
              <span>{{c.name}}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="c.id+'-0'">全部</el-menu-item>
              <el-menu-item
                v-for="child in c.childNode"
                :key="child.id"
                :index="c.id+'-'+child.id"
              >{{child.name}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->
        </el-menu>
      </el-col>

      <el-col :span="18">
        <el-row class="header">
          <el-col :span="20">
            <input type="text" v-model="keyWords">
          </el-col>
          <el-col :span="4">
            <el-button type="primary" class="search" @click="search">搜索</el-button>
          </el-col>
        </el-row>

        <div class="list" v-loading="loading">
          <Item class="boxShadow" v-for="c in corpList" :key="c.corpId" :info="c"></Item>
        </div>

        <div class='pages main-pagination' v-if="pageTotal > 8">
          <el-pagination :page-size="8" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="pageTotal"></el-pagination>
        </div>

        <Nothing v-if="!corpList.length && !loading"></Nothing>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Item from './child/Item';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      keyWords: '',
      categoryList: [],
      categoryId1: 0, // 企业分类一级id
      categoryId2: 0, // 企业分类二级id
      corpList : [],
      pageIndex: 1,
      pageTotal: 0,
      loading: true,
    };
  },
  components: { Item },
  methods: {
    getCorpCategoryTree() { // 获取企业分类树
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/corp/category/tree`).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.categoryList = res.resData;
        }
      });
    },
    selectMenu(index, indexPath){
      console.log(indexPath);
      this.pageIndex = 1
      if(indexPath.length == 1){ // 只有一个成员表示点击了“全部”
        this.categoryId1 = index;//原0修改
        this.categoryId2 = 0;
        this.getCorpList();
      } else {
        let path = indexPath[1].split('-');
        this.categoryId1 = path[0];
        this.categoryId2 = path[1];
        this.getCorpList();
      }
    },
    // 获取企业列表详情
    getCorpDetail() {
      let param = {
        corp_id: "4747",
        park_id: 1000
      };
      this.$http.post(`${this.URL_PREFIX}/mgmt/park/corp/detail`, param).then((response) => {
          console.log(response);
      });
    },
    // 获取企业列表
    getCorpList() {
      this.loading = true;
      let param = {
        currPage: this.pageIndex,
        pageRows: 8,
        parkId: this.currentParkId,
      };
      if(this.categoryId1 > 0) param.categoryLevel1 = this.categoryId1;
      if(this.categoryId2 > 0) param.categoryLevel2 = this.categoryId2;
      if(this.keyWords !== '') param.corpName = this.keyWords;
      this.$http.post(`${this.URL_PREFIX}/app/get/corp/info/list`, param).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.corpList = res.resData.pageList || [];
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    // 搜索
    search(){
      this.pageIndex = 1
      this.getCorpList()
    },
    // 改变页数
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getCorpList();
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user']),
  },
  mounted() {
    this.getCorpCategoryTree();
    this.getCorpList();
    this.getCorpDetail();
  },
}
</script>

<style lang="scss" scoped>
  @import '~@scss';
  .header {
    input {
      box-sizing: border-box;
      width: 100%;
      padding: 10px;
      border: 1px solid $color-main;
    }
    .search {
      width: 100%;
      border-radius: 0;
      font-size: 15px;
    }
  }
  .list{
    margin-top: 20px;
  }
  .pages{
    margin-top: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/navigator/corpList/components/List.vue